import { useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import SelectableState from '../../../contexts/local/selectable/SelectableState';
import ProcessContext from '../../../contexts/process/ProcessContext';
import PanelSelector from '../transplanting/PanelSelector';
import PanelSlotSelection from './PanelSlotSelection';
import WeighingContainer from './WeighingContainer';
import HarvestingProcedureSelection from './HarvestingProcedureSelection';
import Loading from '../../ui-elements/Loading';

const Harvesting = () => {
  const navigate = useNavigate();

  const { processFinished, occupancyArray, finishProcess, additionalProcessInformation } = useContext(ProcessContext);
  const completingRef = useRef(false);
  const currentProcessStep = additionalProcessInformation?.processStep;
    const panel = additionalProcessInformation?.sourceEntity;
  const plantSlot = additionalProcessInformation?.selectedPlantSlotOrdinalNumbers;
  const availableItems = occupancyArray
    .map((channel) =>
      channel.plantSlotBlocks.filter((block) => block.isOccupied && block.produceTypeId != null).map((block) => block.startPlantSlotOrdinalNumber)
    )
    .flat();

  useEffect(() => {
    return () => {
      if (!completingRef.current) {
         finishProcess();
      }
    }
  }, []);

  useEffect(() => {
    if (processFinished) {
      navigate('/');
    }
  }, [navigate, processFinished]);


  const renderByStep = () => {
    if (!currentProcessStep) return <Loading fullScreen />;

    switch (currentProcessStep) {
      case 1:
      // HandleHarvestingProcedureSelection in HarvestingProcess.cs
        return (
          <HarvestingProcedureSelection />
        );

      case 2:
        // HandlePanelSelection in HarvestingProcess.cs
        return (
          <PanelSelector panel={panel} />
        );

      case 3:
        // Handle PanelSlotSelection in HarvestingProcess.cs
        return (
          <SelectableState availableItems={availableItems}>
            <PanelSlotSelection harvesting={true} slots={plantSlot} />
          </SelectableState>
        );

      case 4:
        // HandleWeighingAssignment in HarvestingProcess.cs
        return (
          <WeighingContainer completingRef={completingRef} />
        );
        case 5:
          // HandleConfirmation in HarvestingProcess.cs
          return (
            <WeighingContainer completingRef={completingRef} />
          );
      default:
        return <Loading fullScreen />;
    }
  };

  return (
    <div id='harvesting-container' className='process-container'>
      {renderByStep()}
    </div>
  );
};

export default Harvesting;
